export const AWS_RESPONSIBLE_AI_POLICY_URL =
  "https://aws.amazon.com/ai/responsible-ai/policy/";
